import DocumentsRestModel from '@/api/RestModels/documents';

export default class Documents {
  constructor(store) {
    this.$store = store;
  }

  /**
   * @typedef { Object } FileDownloadRequestModel
   * @param { string } fileUrl
   */

  /**
   * @param { FileDownloadRequestModel } payload
   * @returns {Promise<void>}
   */
  async get(payload) {
    const self = this;
    try {
      const data = await DocumentsRestModel.get(payload);
      return data
    } catch (err) {
      return err;
    }
  }
}
